<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">财务系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提现白名单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="never" class="page-content">
      <!-- 用户账号和钱包地址并排布局 -->
      <div class="table-container">
        <!-- 用户账号列表 -->
        <div class="master-list">
          <div class="page-actions">
            <el-button type="primary" @click="handleAddMaster">添加用户账号</el-button>
          </div>
          <el-table
              :data="paginatedMasterAccounts"
              border
              :row-class-name="setRowClassName"
              :row-style="highlightRowStyle"
              @row-click="selectMaster"
          >
            <el-table-column label="用户账号UID" width="230">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <!-- 为按钮添加native修饰符防止事件冒泡 -->
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    circle
                    size="small"
                    @click.native.stop="handleEditMaster(scope.row)"
                ></el-button>
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="small"
                    @click.native.stop="handleDeleteMaster(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
          ></el-pagination>
        </div>

        <!-- 钱包地址列表 -->
        <div class="sub-list">
          <div class="page-actions">
            <el-button type="primary" :disabled="currentMaster === ''" @click="handleAddSub">添加钱包地址</el-button>
            <div class="current-master-hint">当前用户账号：<label style="color: #e2696a">{{ currentMaster }}</label></div>
          </div>
          <el-table :data="subAccounts" border>
            <el-table-column label="钱包地址">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="small"
                    @click="handleDeleteSub(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TransferApprovalWhitelist',
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  async mounted() {
    await this.fetchWhitelist();
  },
  computed: {
    ...mapState('withdrawApprovalWhitelist', ['whitelist', 'currentMaster', 'masterOrder']), // 引入 masterOrder
    masterAccounts() {
      return this.masterOrder || [];
    },
    paginatedMasterAccounts() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.masterAccounts.slice(start, end);
    },
    total() {
      return this.masterAccounts.length;
    },
    subAccounts() {
      return this.currentMaster ? this.whitelist[this.currentMaster] : [];
    }
  },
  methods: {
    setRowClassName({ row }) {
      return row === this.currentMaster ? 'highlight-row' : '';
    },
    highlightRowStyle({ row }) {
      return row === this.currentMaster
          ? {
            'background-color': '#ebedf0',
            'color': '#55a4ed',
            'font-weight': '500'
          }
          : null;
    },
    ...mapActions('withdrawApprovalWhitelist', ['fetchWhitelist', 'updateList', 'updateMasterList']),
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    selectMaster(master) {
      this.$store.commit('withdrawApprovalWhitelist/setCurrentMaster', master);
    },

    handleAddMaster() {
      this.$prompt('请输入用户账号UID', '添加用户账号', {
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字UID'
      }).then(({ value }) => {
        return this.updateMasterList({ newKey: value });
      }).then(() => {
        this.$message.success('用户账号添加成功');
        this.fetchWhitelist();
      }).catch((error) => {
        if (error !== 'cancel') {
          this.$message.error('添加用户账号失败');
        }
      });
    },

    handleEditMaster(master) {
      this.$prompt('请输入新的用户账号UID', '编辑用户账号', {
        inputValue: master, // 预填充当前用户账号UID
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字UID'
      }).then(({ value }) => {
        if (value === master) {
          this.$message.info('未进行修改');
          return;
        }
        return this.updateMasterList({
          oldKey: master,
          newKey: value
        });
      }).then(() => {
        this.$message.success('用户账号修改成功');
        this.fetchWhitelist();
      }).catch((error) => {
        if (error !== 'cancel') {
          this.$message.error('修改用户账号失败');
        }
      });
    },

    async handleDeleteMaster(master) {
      try {
        await this.$confirm('确认删除该用户账号及其所有钱包地址？', '提示', { type: 'warning' });
        await this.updateMasterList({
          oldKey: master,
        });
        this.$message.success('删除成功');

        await this.fetchWhitelist();
        this.$store.commit('withdrawApprovalWhitelist/setCurrentMaster', null);

        if (this.paginatedMasterAccounts.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
        }
      } catch (e) {}
    },

    handleAddSub() {
      this.$prompt('请输入钱包地址（归属用户账号：' + this.currentMaster + '）', '添加钱包地址', {
        inputPattern: /^[a-zA-Z0-9]+$/,
        inputErrorMessage: '请输入有效的钱包地址'
      }).then(({ value }) => {
        // 确保 value 不为空
        if (!value) return;

        // 获取当前主账户的子账户列表
        const currentSubs = this.subAccounts;

        // 检查是否已存在该钱包地址
        if (currentSubs.includes(value)) {
          this.$message.warning('该钱包地址已存在');
          return;
        }

        // 添加新的钱包地址
        const newSubs = [...currentSubs, value];

        // 修正：直接传递数组而非对象
        this.updateList(newSubs);
        this.$message.success('钱包地址添加成功');
      }).catch(() => {
        // 取消操作
      });
    },

    async handleDeleteSub(index) {
      await this.$confirm('确认删除该钱包地址？', '提示', { type: 'warning' });
      const newSubs = [...this.subAccounts];
      newSubs.splice(index, 1);

      // 修正：直接传递数组而非对象
      this.updateList(newSubs);
      this.$message.success('钱包地址删除成功');
    },

    handleMasterSubmit({ oldKey, newKey }) {
      this.updateMasterList({
        oldKey,
        newKey,
        subs: oldKey ? this.whitelist[oldKey] : []
      }).then(() => {
        this.handleMasterDialogClose();
        this.$store.state.withdrawApprovalWhitelist.whitelist = {
          [newKey]: [],
          ...this.$store.state.withdrawApprovalWhitelist.whitelist
        };
        this.fetchWhitelist();
      });
    },
  }
};
</script>

<style scoped>
.table-container {
  display: flex;
  gap: 0; /* 确保子元素之间没有间距 */
  padding: 0; /* 移除内边距 */
  border: none; /* 移除边框 */

  /* 调整弹性布局的对齐方式 */
  align-items: stretch;
  justify-content: flex-start; /* 修改：使子元素靠左对齐 */
}

.master-list {
  flex: 1;
  max-width: 462px;
  margin-left: 0; /* 删除负边距 */
}

.sub-list {
  flex: 1;
  max-width: 580px;
  margin-left: 15px; /* 添加固定间距 */
}

/* 当前用户账号提示 */
.current-master-hint {
  margin-right: 15px;
  color: #4799f5;
  font-size: 14px;
}
</style>
